const divModalEquipCheckList = {
  groupQuestionArray: 'Checklist sin ninguna pregunta agregada'
};

export default divModalEquipCheckList;
